import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteOidcConfigurationByCustomer } from '../../../../api';

export const adminOidcConfigurationsByCustomerByIdDeleteSlice = createDeleteAsyncSlice({
	name: 'AdminOidcConfigurationsByCustomerById',
	receive: true,
	request: true,
	requestHandler: deleteOidcConfigurationByCustomer,
	retainDataOnRequest: false
});
